import { getPayoutList, conslusionPayout } from "@/api/";

const initState = () => ({
  currentPayout: {},
  filter: [],
  total: 0,
  search_query: "",
  page: 1,
  pageSize: 30,
  showModal: false,
  payouts: [],
  statuses: {
    process: {
      label: 'В процессе',
      bgColor: "#FAE6AA",
      textColor: "#B79310",
    },
    error: {
      label: 'Ошибка',
      bgColor: "#F9C1BD",
      textColor: "#B79310",
    },
    wait_conclusion: {
      label: 'Ожидание подтверждения',
      bgColor: "#FAE6AA",
      textColor: "#B79310",
    },
    cancel: {
      label: 'Отменен',
      bgColor: "#F9C1BD",
      textColor: "#B79310",
    },
    success: {
      label: 'Успешно',
      bgColor: "#D4F296",
      textColor: "#5E8C00",
    },
  }
});

export default {
  namespaced: true,
  state: initState,
  getters: {
    dateFilter: state => {
      const filter = state.filter.find(f => f.field === "dadd");
      if (filter) {
        const result = {};
        // 'gte' - дата начала периода, 'lte' - дата конца периода
        const start = filter.filters.find(f => f.operator === "gte");
        const end = filter.filters.find(f => f.operator === "lte");
        if (start) {
          result.start = start.value;
        }
        if (end) {
          result.end = end.value;
        }
        return result;
      }
      return null;
    },

    getCurrentPayout: state => state.currentPayout
  },

  mutations: {
    setPayouts: (state, payload) => (state.payouts = payload),
    setShowModal: (state, payload) => {
      if (payload) {
        state.currentPayout = payload
      } else {
        state.currentPayout = {}
      }
      state.showModal = !state.showModal
    },
    setTotal: (state, payload) => (state.total = payload),
    setPageSize: (state, payload) => (state.pageSize = payload),
    setPage: (state, payload) => (state.page = payload),
    setSearchQuery: (state, payload) => (state.search_query = payload),
    setDateFilter: (state, payload) => {
      state.filter = state.filter.filter(({ field }) => field !== "dadd");

      const daddFilter = {
        field: "dadd",
        logic: "and",
        filters: []
      };

      if (payload.start) {
        daddFilter.filters.push({
          operator: "gte",
          value: payload.start
        });
      }
      if (payload.end) {
        daddFilter.filters.push({
          operator: "lte",
          value: payload.end
        });
      }

      if (daddFilter.filters.length > 0) {
        state.filter.push(daddFilter);
      }
    },
    reset: state => {
      const initialState = initState();
      Object.keys(initialState).forEach(key => (state[key] = initialState[key]));
    }
  },
  actions: {
    async getAllPayouts({ commit, state: { page, pageSize, filter, search_query }, rootGetters }) {
      if (!rootGetters["profile/canSeePayouts"]) {
        console.error("Access to payouts list denied");
        return;
      }

      const response = await getPayoutList({
        page,
        pageSize,
        filter,
        search_query
      });

      if (response) {
        commit("setPayouts", response.list);
        commit("setTotal", response.total);
      }
      return response;
    },

    async setConclusion({ commit }, {id, result}) {
      const response = await conslusionPayout({ id, result });
      return response;
    }
  }
};
